import { useTranslation } from 'react-i18next';

import { ShimmerImageWrapper, ShimmerTextWrapper } from '../../../../../../../../../components';
import { Organization } from '../../../../../../../../../types/api.graphql';
import { getInitials } from '../../../../../../../../../utils/User';
import { AvatarImage, ConnectionLabel, Container, OrganizationName } from './OrganizationItem.styles';

interface OrganizationItemProps {
  organization?: Organization;
  onClick?: (org: Organization) => void;
  isConnection?: boolean;
  loading?: boolean;
}

export const OrganizationItem = ({ organization, onClick, isConnection, loading }: OrganizationItemProps) => {
  const { t } = useTranslation();

  return (
    <Container onClick={() => onClick(organization)}>
      <ShimmerImageWrapper $width="2rem" $height="2rem" loading={loading}>
        <AvatarImage text={getInitials(organization?.name)} src={organization?.imageUrl} />
      </ShimmerImageWrapper>
      <ShimmerTextWrapper $height="2rem" $width="5rem">
        <OrganizationName>{organization?.name}</OrganizationName>
        {isConnection && <ConnectionLabel>{t('vdp.shareModal.connection')}</ConnectionLabel>}
      </ShimmerTextWrapper>
    </Container>
  );
};

export default OrganizationItem;
